import { render, staticRenderFns } from "./Copywrite.vue?vue&type=template&id=1e9ae74d&scoped=true&"
import script from "./Copywrite.vue?vue&type=script&lang=js&"
export * from "./Copywrite.vue?vue&type=script&lang=js&"
import style0 from "./Copywrite.vue?vue&type=style&index=0&id=1e9ae74d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9ae74d",
  null
  
)

export default component.exports